import { render } from "./SalesReturnListPage.vue?vue&type=template&id=b08d3e3e&ts=true"
import script from "./SalesReturnListPage.vue?vue&type=script&lang=ts"
export * from "./SalesReturnListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__